import { useState } from 'react';

import { IconButton } from 'design-system';
import { Trash2 } from 'lucide-react';

import { useAppForm } from '@/features/dashboard/components/AppForm/AppForm/context';
import type { TabSymbol } from '@/features/dashboard/components/AppForm/AppForm/context/types';
import { ConfirmationDialog } from '@/features/dashboard/components/ConfirmationDialog';
import { dashboardConfirmationPresets } from '@/features/dashboard/components/ConfirmationDialog/presets';
import { DashboardNameInput } from '@/features/dashboard/components/DashboardNameInput';
import { SymbolAlias } from '@/features/dashboard/components/SymbolAlias';

export const SymbolContent = ({ symbol, index }: { symbol: TabSymbol; index: number }) => {
  const { updateSymbol, removeSymbol, form, setCanPreview } = useAppForm();
  const type = form.state.values?.type;
  const [isDelete, setIsDelete] = useState(false);

  return (
    <div className='flex items-center'>
      <div className='flex min-w-0 flex-1 items-center gap-3 overflow-hidden pr-2'>
        <span className='text-sm'>#{index + 1}</span>
        <span className='ml-6 w-[100px] text-sm'>
          <SymbolAlias
            symbol={symbol}
            type={type}
          />
        </span>

        <div className='min-w-0 flex-1'>
          <DashboardNameInput
            value={symbol.shortTitle}
            onBlur={() => {
              setCanPreview(true);
            }}
            onChange={value => {
              updateSymbol({
                ...symbol,
                shortTitle: value
              });
            }}
            onFocus={() => {
              setCanPreview(false);
            }}
          />
        </div>
      </div>
      <IconButton
        label='Remove item'
        size='icon'
        variant='ghost'
        onClick={() => {
          setIsDelete(true);
        }}
      >
        <Trash2 />
      </IconButton>
      <ConfirmationDialog
        open={isDelete}
        {...dashboardConfirmationPresets.removeItem}
        onCancel={() => {
          setIsDelete(false);
        }}
        onConfirm={() => {
          removeSymbol(symbol);
          setIsDelete(false);
        }}
      />
    </div>
  );
};
